import React, { Component } from 'react';
import './App.css';
import Sitemap from './components/sitemap/siteMap';
 

class App extends Component {
  render() {
    return (
      <div className="App">
        <Sitemap />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js